module.exports = __webpack_public_path__ + "media/images/fallback_presentation-2d3f8365ecc7fa0105bd71da9a4b4508.png";